<template>
    <div>
        <div v-if="isSent || isAlreadyPending"><PendingStatus @helpClick="closeModal"/></div>
        <template v-else>
            <h4 class="instruction-important">{{ $t('upload a document photo') | capitalize }}</h4>

            <DocumentUploadForm @success="onSuccess" />
        </template>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import PendingStatus from '@modules/userProfile/idCardVerification/components/PendingStatus';
    import { routeNames } from '@app/router';
    import { NotificationType } from '@models/user/enums';
    import DocumentUploadForm from '@modules/userProfile/documentUpload/components/DocumentUploadForm';
    import { isIdCardVerificationPending, setIdCardVerificationPending } from '@models/user/UserDataService';

    export default {
        name: 'IdCardVerificationModal',
        data() {
            return {
                isSent: false,
            };
        },
        computed: {
            ...mapGetters('data/authentication', [
                'user',
            ]),
        },
        created() {
            this.isAlreadyPending = isIdCardVerificationPending(this.user);
            if (!this.isAlreadyPending) {
                // because, after 3 days user can upload again!
                this.removeNotification(NotificationType.idCardVerificationPending);
            }
        },
        methods: {
            ...mapActions('ui/modal', [
                'closeModal',
            ]),
            ...mapActions('ui/user/account', [
                'setIsIdCardVerificationPending',
            ]),
            ...mapActions('ui/user/notifications', [
                'addNotification',
                'removeNotification',
            ]),
            onSuccess() {
                setIdCardVerificationPending(this.user);
                this.addNotification({
                    title: 'Know your user pending',
                    type: NotificationType.idCardVerificationPending
                });
                this.setIsIdCardVerificationPending(true);
                this.isSent = true;
            }
        },
        destroyed() {
            this.$router.push({ name: routeNames.profile });
        },
        components: {
            PendingStatus,
            DocumentUploadForm
        }
    };
</script>



// WEBPACK FOOTER //
// src/app/modals/modals/userProfile/idCardVerification/IdCardVerificationModal.vue